// extracted by mini-css-extract-plugin
module.exports = {"authorBlock":"article-page_authorBlock__VuUv2","layoutContainer":"article-page_layoutContainer__rkkRi","video-spin":"article-page_video-spin__OsrQ5"};